
export default function AboutUs() {
  return (
    <section className="py-20 bg-gray-800" id="sobre-nosotros">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-gray-700 px-8 py-4 rounded-2xl border border-gray-600 mb-8">
            <h2 
              className="text-3xl font-thin text-white"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Sobre Nosotros
            </h2>
          </div>
          <div className="w-24 h-1 bg-[#C6A45C] mx-auto mb-8"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/62d50e0694ed1fb86e7498ab23d93b53.jpg"
              alt="Perra Luxury Boutique"
              className="w-full h-96 object-cover rounded-lg shadow-2xl"
            />
          </div>
          
          <div className="space-y-6">
            <p 
              className="text-lg text-gray-300 leading-relaxed font-thin"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Perra Luxury celebra la actitud y el poder de la mujer que no pide permiso para 
              brillar. Cada cartera es una pieza de autor, cuidadosamente seleccionada de las mejores 
              boutiques de Miami y Europa.
            </p>
            
            <p 
              className="text-lg text-gray-300 leading-relaxed font-thin"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Nos especializamos en carteras importadas de la más alta calidad, trabajando directamente 
              con diseñadores y casas de moda reconocidas internacionalmente. Cada pieza cuenta una 
              historia de elegancia, sofisticación y exclusividad.
            </p>
            
            <p 
              className="text-lg text-gray-300 leading-relaxed font-thin"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Nuestro compromiso es ofrecer accesorios únicos que reflejen la personalidad y el estilo 
              de cada mujer, porque creemos que la verdadera elegancia viene de la confianza en una misma.
            </p>

            <div className="grid grid-cols-2 gap-6 mt-8">
              <div className="text-center p-6 bg-gray-700 rounded-lg">
                <h4 className="text-2xl font-thin text-[#C6A45C] mb-2" style={{ fontFamily: '"Lato", sans-serif' }}>100+</h4>
                <p className="text-gray-300 text-sm font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>Diseños Exclusivos</p>
              </div>
              <div className="text-center p-6 bg-gray-700 rounded-lg">
                <h4 className="text-2xl font-thin text-[#C6A45C] mb-2" style={{ fontFamily: '"Lato", sans-serif' }}>5★</h4>
                <p className="text-gray-300 text-sm font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>Calidad Premium</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
